// Copyright (c) 2019 Deere & Company

import {
    isNotEmpty,
    isNumberInputValid,
    validateClaimUseAmountUnits,
    validateClaimUseAmounts,
    validateUseAmountsIfPinExists
} from '../../shared/services/claim-shared-helper';

export const isValidClaim = (claim, allowedUnitsLength) => [
    isNotEmpty(claim.failureInfo.failurePartNumber),
    isNotEmpty(claim.referenceInfo.referenceNumber1),
    isNotEmpty(claim.responsibleAccount.account),
    validateUseAmountsIfPinExists(claim, allowedUnitsLength),
    isNumberInputValid(claim.failureInfo.repairDate),
    isNotEmpty(claim.customer.customerName),
    isNotEmpty(claim.pin)
].every(rule => rule);

export const mapFormValidation = (property, value, claim) => {

    const map = {
        customerName: isNotEmpty,
        failurePart: isNotEmpty,
        pin: isNotEmpty,
        programName: isNotEmpty,
        repairDate: isNumberInputValid,
        responsibleAccount: isNotEmpty,
        useAmount: validateClaimUseAmounts,
        useAmountUnit: validateClaimUseAmountUnits,
        workOrderOne: isNotEmpty

    };

    return map[property](value, claim);

};

export const checkClaimValidity = (currentPageValidity, validationFailed, selectedAction) =>
    selectedAction === 'VALIDATE' ?
        !validationFailed && !currentPageValidity :
        false;



// WEBPACK FOOTER //
// ./src/claim/incentive/services/claim-validation-helper.js